import APIService from "./APIService";

const ChatAPI = {
  /**
   * Send a chat message and receive an AI response.
   */
  sendMessage: async (
    message,
    currentPage,
    conversationId,
    userContext = {},
  ) => {
    try {
      const response = await APIService.post("/api/v1/app/chat/send", {
        message,
        currentPage,
        conversationId,
        userUuid: userContext.userUuid,
        userName: userContext.userName,
        subscriptionTier: userContext.subscriptionTier,
        onboardingComplete: userContext.onboardingComplete,
        safetyScore: userContext.safetyScore,
      });
      return response;
    } catch (error) {
      console.error("[ChatAPI] Error sending message:", error);
      throw error;
    }
  },

  /**
   * Get messages for a specific conversation.
   */
  getConversationMessages: async (conversationId, userUuid) => {
    try {
      const response = await APIService.get(
        `/api/v1/app/chat/conversations/${conversationId}/messages?userUuid=${userUuid}`,
      );
      return response;
    } catch (error) {
      console.error("[ChatAPI] Error fetching messages:", error);
      throw error;
    }
  },

  /**
   * Get all conversations for the current user.
   */
  getUserConversations: async (userUuid) => {
    try {
      const response = await APIService.get(
        `/api/v1/app/chat/conversations?userUuid=${userUuid}`,
      );
      return response;
    } catch (error) {
      console.error("[ChatAPI] Error fetching conversations:", error);
      throw error;
    }
  },

  /**
   * Start a new conversation (archives current active ones).
   */
  newConversation: async (userUuid) => {
    try {
      const response = await APIService.post(
        "/api/v1/app/chat/conversations/new",
        { userUuid },
      );
      return response;
    } catch (error) {
      console.error("[ChatAPI] Error creating new conversation:", error);
      throw error;
    }
  },

  /**
   * End/archive a conversation.
   */
  endConversation: async (conversationId, userUuid) => {
    try {
      const response = await APIService.post(
        `/api/v1/app/chat/conversations/${conversationId}/end`,
        { userUuid },
      );
      return response;
    } catch (error) {
      console.error("[ChatAPI] Error ending conversation:", error);
      throw error;
    }
  },
};

export default ChatAPI;
